import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/LoginPage";
import AdminHomePage from "./pages/admin/AdminHomePage";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import AdminNominationsPage from "./pages/admin/AdminNominationsPage";
import AdminSubmissionPage from "./pages/admin/AdminSubmissionPage";
import AdminJuryPage from "./pages/admin/AdminJuryPage";
import AdminEmailTemplatesPage from "./pages/admin/AdminEmailTemplatesPage";
import AdminCoveragePage from "./pages/admin/AdminCoveragePage";
import AdminDelegatesEventsPage from "./pages/admin/AdminDelegatesEventsPage";
import AdminDelegatesSubmissionsPage from "./pages/admin/AdminDelegatesSubmissionsPage";
import JuryEventsPage from "./pages/jury/JuryEventsPage";
import JuryNominationsPage from "./pages/jury/JuryNominationsPage";
import JuryScoringPage from "./pages/jury/JuryScoringPage";
import { isAdmin, isJury, hasDeclared, getUser } from "./auth";
import { DeclarationGate } from "./components/DeclarationModal";

function RequireAdmin({ children }) {
  return isAdmin() ? children : <Navigate to="/login" replace />;
}
// Jury screens are gated on the declaration for the whole session, not just at login
function RequireJury({ children }) {
  const [declared, setDeclared] = useState(hasDeclared());
  if (!isJury()) return <Navigate to="/login" replace />;
  return (
    <DeclarationGate
      juryName={getUser()?.name || "Juror"}
      declared={declared}
      onAccepted={() => setDeclared(true)}
    >
      {children}
    </DeclarationGate>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route path="/admin" element={<RequireAdmin><AdminHomePage /></RequireAdmin>} />
        <Route path="/admin/events" element={<RequireAdmin><AdminEventsPage /></RequireAdmin>} />
        <Route path="/admin/events/:eventId/nominations" element={<RequireAdmin><AdminNominationsPage /></RequireAdmin>} />
        <Route path="/admin/submissions/:submissionId" element={<RequireAdmin><AdminSubmissionPage /></RequireAdmin>} />
        <Route path="/admin/jury" element={<RequireAdmin><AdminJuryPage /></RequireAdmin>} />
        <Route path="/admin/events/:eventId/email-templates" element={<RequireAdmin><AdminEmailTemplatesPage /></RequireAdmin>} />
        <Route path="/admin/events/:eventId/coverage" element={<RequireAdmin><AdminCoveragePage /></RequireAdmin>} />
        <Route path="/admin/delegates" element={<RequireAdmin><AdminDelegatesEventsPage /></RequireAdmin>} />
        <Route path="/admin/delegates/:eventId" element={<RequireAdmin><AdminDelegatesSubmissionsPage /></RequireAdmin>} />

        <Route path="/jury/events" element={<RequireJury><JuryEventsPage /></RequireJury>} />
        <Route path="/jury/events/:eventId/nominations" element={<RequireJury><JuryNominationsPage /></RequireJury>} />
        <Route path="/jury/score/:submissionId" element={<RequireJury><JuryScoringPage /></RequireJury>} />

        <Route path="/" element={
          isAdmin() ? <Navigate to="/admin" replace /> :
          isJury()  ? <Navigate to="/jury/events"  replace /> :
                      <Navigate to="/login"         replace />
        } />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
